/**
 * @generated SignedSource<<1975a0b44242a505cc0cb644dec43166>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteChatMessageInput = {
  clientMutationId?: string | null;
  chatMessageId: string;
};
export type ChatbotPatternEditScreenContainer_DeleteChatMessageMutation$variables = {
  input: DeleteChatMessageInput;
};
export type ChatbotPatternEditScreenContainer_DeleteChatMessageMutationVariables = ChatbotPatternEditScreenContainer_DeleteChatMessageMutation$variables;
export type ChatbotPatternEditScreenContainer_DeleteChatMessageMutation$data = {
  readonly deleteChatMessage: {
    readonly deletedChatMessageId: string;
  } | null;
};
export type ChatbotPatternEditScreenContainer_DeleteChatMessageMutationResponse = ChatbotPatternEditScreenContainer_DeleteChatMessageMutation$data;
export type ChatbotPatternEditScreenContainer_DeleteChatMessageMutation = {
  variables: ChatbotPatternEditScreenContainer_DeleteChatMessageMutationVariables;
  response: ChatbotPatternEditScreenContainer_DeleteChatMessageMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteChatMessagePayload",
    "kind": "LinkedField",
    "name": "deleteChatMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedChatMessageId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatbotPatternEditScreenContainer_DeleteChatMessageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatbotPatternEditScreenContainer_DeleteChatMessageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5c0ddea49175c3799906e3d1f0454df4",
    "id": null,
    "metadata": {},
    "name": "ChatbotPatternEditScreenContainer_DeleteChatMessageMutation",
    "operationKind": "mutation",
    "text": "mutation ChatbotPatternEditScreenContainer_DeleteChatMessageMutation(\n  $input: DeleteChatMessageInput!\n) {\n  deleteChatMessage(input: $input) {\n    deletedChatMessageId\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba0a5a7b374e00a48ee2942cbd42e8f6";

export default node;
